module.exports = __webpack_public_path__ + "img/search.bc1e3bf8.svg";